import React, {Component} from 'react';
import {Breadcrumb} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";

import StoreCategoryData from "../../data/StoreCategoryData";
import CustomDivider from '../../components/extras/CustomDivider';
import CategoryDialog from "../../components/inventories/CategoryDialog";
import DynamicTable from "../../components/extras/DynamicTable";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import connect from "react-redux/es/connect/connect";
import {showToast} from "../../actions/ToastAction";
import {categoryDialog} from "../../actions/CategoryDialogActions";
import QuestionDialog from "../../components/extras/QuestionDialog";

class Categories extends Component {

    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Nombre', 'Activa', 'Acciones'],
                name: 'Categoría',
                title: 'Categorías',
                has_actions: true,
                edit: true,
                can_add: true,
                pagination: true,
                delete: true,
                url: 'store-categories',
                values: ['id', 'name', 'active'],
                boolean_fields: ['active'],
                id: 'table_categories'
            },
        };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.category_select && nextProps.category_select.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.category_select);
        }
    }

    delete = (id) => {
        StoreCategoryData.deleteCategoryStore(id, (res) => {
            if (res === null) {
                this.props.dynamicTableDelete(id);
                this.props.showToast({message: 'Categoría Borrada!', type: 'success'});
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
        });
    };

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.categoryDialog({open:true, category:{id:null}});
        }else if(response.event === 'edit'){
            this.props.categoryDialog({open:true, category:response.data});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        }
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Categorías | Inventarios - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/inventories'>Inventarios</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Categorías</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <CategoryDialog />
                <QuestionDialog ref="deleteDialog" message="Borrar esta categoría" callbackConfirm={this.delete}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        category_select: state.get('category_select'),
    };
}

function mapDispatchToProps(dispatch){
    return {
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        showToast(data){
            dispatch(showToast(data))
        },
        categoryDialog(data) {
            dispatch(categoryDialog(data));
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Categories)



// WEBPACK FOOTER //
// ./src/containers/inventories/Categories.js